/* eslint-disable filename-export/match-default-export */
import { useEffect } from 'react';

const useScrollToTop = (pathname, elementId) => {
  useEffect(() => {
    const layout = document.getElementById(elementId);

    if (layout) {
      setTimeout(() => layout.scrollTo({ top: 0, behavior: 'smooth' }));
    }
  }, [pathname, elementId]);
};

export default useScrollToTop;
